<script>
import { required } from "vuelidate/lib/validators";

import name_residential_unit from "../../../helpers/list/name_residential_unit";
import city from "../../../helpers/list/city";
import type_residential_unit from "../../../helpers/list/type_residential_unit";
// import style_residential_unit from "../../../helpers/list/style_residential_unit";
import area_residential_unit from "../../../helpers/list/area_residential_unit";

export default {
  components: {},
  props: {},

  data() {
    return {
      name_residential_unit_id: "",
      city_id: "",
      type_residential_unit_id: "",
      // style_residential_unit_id: "",
      area_residential_unit_id: "",

      //lists
      list_name_residential_unit: name_residential_unit,
      list_city: city,
      list_type_residential_unit: type_residential_unit,
      // list_style_residential_unit: style_residential_unit,
      list_area_residential_unit: area_residential_unit,
    };
  },
  validations: {
    name_residential_unit_id: { required },
    city_id: { required },
    type_residential_unit_id: { required },
    // style_residential_unit_id: { required },
    area_residential_unit_id: { required },
    form: [
      "name_residential_unit_id",
      "city_id",
      "type_residential_unit_id",
      // "style_residential_unit_id",
      "area_residential_unit_id",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- شهيد -->
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">حدد مواصفات الوحدة السكنية</h5></div>

      <b-form-group
        class="col-md-6 mb-3"
        label=" اسم الوحدة السكنية : "
        label-for="name_residential_unit_id"
      >
        <select
          class="form-control"
          id="name_residential_unit_id"
          v-model="name_residential_unit_id"
          :class="{ 'is-invalid': $v.name_residential_unit_id.$error }"
        >
          <option value="">اختر الوحدة السكنية</option>
          <option
            v-for="name_residential_unit in list_name_residential_unit"
            :value="name_residential_unit.id"
            :key="name_residential_unit.id"
          >
            {{ name_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.name_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.name_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" المحافظة  : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in list_city" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" نوع الوحدة السكنية : "
        label-for="type_residential_unit_id"
      >
        <select
          class="form-control"
          id="type_residential_unit_id"
          v-model="type_residential_unit_id"
          :class="{ 'is-invalid': $v.type_residential_unit_id.$error }"
        >
          <option value="">اختر نوع الوحدة السكنية</option>
          <option
            v-for="type_residential_unit in list_type_residential_unit"
            :value="type_residential_unit.id"
            :key="type_residential_unit.id"
          >
            {{ type_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.type_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.type_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>

      <!-- <b-form-group
        class="col-md-4 mb-3"
        label=" نمط الوحدة السكنية : "
        label-for="style_residential_unit_id"
      >
        <select
          class="form-control"
          id="style_residential_unit_id"
          v-model="style_residential_unit_id"
          :class="{ 'is-invalid': $v.style_residential_unit_id.$error }"
        >
          <option value="">اختر نمط الوحدة السكنية</option>
          <option
            v-for="style_residential_unit in list_style_residential_unit"
            :value="style_residential_unit.id"
            :key="style_residential_unit.id"
          >
            {{ style_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.style_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.style_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group> -->

      <b-form-group
        class="col-md-6 mb-3"
        label=" مساحة الوحدة السكنية : "
        label-for="area_residential_unit_id"
      >
        <select
          class="form-control"
          id="area_residential_unit_id"
          v-model="area_residential_unit_id"
          :class="{ 'is-invalid': $v.area_residential_unit_id.$error }"
        >
          <option value="">اختر مساحة الوحدة السكنية</option>
          <option
            v-for="area_residential_unit in list_area_residential_unit"
            :value="area_residential_unit.id"
            :key="area_residential_unit.id"
          >
            {{ area_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.area_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.area_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
